import React from 'react';
import "./footer_view.css";
import { scrollToSectionUtils } from '../../../core/utils/scroll_to_section_ultils.jsx';
import { FaFacebook, FaInstagram, FaLinkedin, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import { footerMapper } from "../utils/mapper/footer_mapper.jsx";

const FooterView = () => {
    const { navLinks, socialLinks, termsLinks } = footerMapper;
    return (
        <div className="footer">
            <div className="container">
                <div className="footer_content">
                    <div className="footer_logo">
                        <div className="logo"></div>
                        <div className="footer_info">
                            {navLinks.map((link) => (
                                <p key={link.id} onClick={() => scrollToSectionUtils(link.id)} style={{ cursor: 'pointer' }}>{link.label}</p>
                            ))}
                        </div>
                    </div>
                    <div className="footer_social">
                        <a href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" className="social_icon_link" aria-label="Facebook">
                            <FaFacebook className="social_icon" />
                        </a>
                        <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="social_icon_link" aria-label="Instagram">
                            <FaInstagram className="social_icon" />
                        </a>
                        <a href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer" className="social_icon_link" aria-label="LinkedIn">
                            <FaLinkedin className="social_icon" />
                        </a>
                        <a href={socialLinks.email} className="social_icon_link" aria-label="E-mail">
                            <FaEnvelope className="social_icon" />
                        </a>
                        <a href={socialLinks.whatsapp} target="_blank" rel="noopener noreferrer" className="social_icon_link" aria-label="WhatsApp">
                            <FaWhatsapp className="social_icon" />
                        </a>
                    </div>
                </div>
                <div className='footer_line'></div>
                <div className='footer_terms_and_privacy'>
                    {termsLinks.map((item) => (
                        <p key={item.id}>{item.text}</p>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FooterView;
